import React, { AllHTMLAttributes, ButtonHTMLAttributes, MouseEvent, useState } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
//import { Hooks } from "@xt/xtbase";
//const { useTranslation } = Hooks;
//import store from "store";
import styles from "./index.module.scss";
interface Props extends AllHTMLAttributes<HTMLElement> {
  attr?: any;
  href?: string;
  onClick?(e: MouseEvent): any;
  children?: React.ReactNode;
}

const index: React.FC<Props> = ({ className, href, onClick, children, ...rest }) => {
  //const t = useTranslation();
  //const {isLogin} = store.user;
  const btnRest = rest as ButtonHTMLAttributes<HTMLButtonElement>;
  /* eslint-disable */
  const [isFocus, setIsFocus] = useState(false);
  return (
    <>
      {href ? (
        <a className={cx(styles["xt-btntxt"], className)} href={href} onClick={onClick} {...rest}>
          {children}
        </a>
      ) : (
        <button
          className={cx(styles["xt-btntxt"], isFocus && "xt-btntxt-focus", className)}
          type="button"
          onClick={onClick}
          {...btnRest}
          onFocus={(e) => {
            e.stopPropagation;
            setIsFocus(true);
          }}
          onBlur={(e) => {
            e.stopPropagation;
            setIsFocus(false);
          }}
          style={rest.style}
        >
          {children}
        </button>
      )}
    </>
  );
};
export default observer(index);
